import { IConfig } from '@cian/config/shared';
import { curry } from 'ramda';
import { IAppState } from '../../redux';
import { getIsNewPublishTermsEnabled } from '../../utils/publishTerms';
import { selectIsAddJKState } from '../jk';

export const selectIsNewPublishTermsEnabled = curry((config: IConfig, state: IAppState): boolean => {
  const { search } = window.location;

  const isAddJKState = selectIsAddJKState(state);

  if (isAddJKState) {
    return false;
  }

  const { isNewPublishTermsEnabled } = state.publishTerms;

  return getIsNewPublishTermsEnabled({ config, search, isNewPublishTermsEnabled });
});
